import { createPopper, Instance } from '@popperjs/core';
import { IComponent } from '../../../src/js/@types/IComponent';
import './navigationMain.css';

interface ICompNavigationMain extends IComponent {
  handleSecondLayer(el: HTMLElement): void;
}

const navigationMain: ICompNavigationMain = {
  name: 'navigationMain',

  handleSecondLayer(navigationMainEl) {
    const popperInstances: Map<HTMLElement, Instance> = new Map();
    let currentViewportIsDesktop = window.innerWidth >= 1024;

    const setup = () => {
      if (!currentViewportIsDesktop) return;

      const menuItems = [
        ...navigationMainEl.querySelectorAll<HTMLElement>(
          '.c-navigationMain__listItem[data-level="1"]',
        ),
      ];

      menuItems.forEach((item) => {
        const triggerEl = item;
        const secondLayer = item.querySelector<HTMLElement>(
          '.c-navigationMain__subItemsWrapper[data-level="1"]',
        );

        if (!triggerEl || !secondLayer) return;

        item.addEventListener('mouseenter', () => {
          // Popper nur erzeugen, wenn noch nicht da
          if (popperInstances.has(item)) {
            popperInstances.get(item)?.update();
            return;
          }

          setTimeout(() => {
            const rect = secondLayer.getBoundingClientRect();
            if (rect.width > 0 && rect.height > 0) {
              const popper = createPopper(triggerEl, secondLayer, {
                placement: 'right-start',
                modifiers: [
                  { name: 'offset', options: { offset: [-8, 0] } },
                  { name: 'flip', enabled: false },
                  {
                    name: 'preventOverflow',
                    options: {
                      boundary: navigationMainEl,
                    },
                  },
                ],
              });
              popperInstances.set(item, popper);
            }
          }, 10);
        });
      });
    };

    const destroyAll = () => {
      popperInstances.forEach((instance) => instance.destroy());
      popperInstances.clear();
    };

    // Initial aufrufen
    setup();

    // Viewport-Wechsel behandeln
    window.addEventListener('resize', () => {
      const isNowDesktop = window.innerWidth >= 1024;
      if (isNowDesktop !== currentViewportIsDesktop) {
        currentViewportIsDesktop = isNowDesktop;
        destroyAll();
        setup();
      }
    });
  },

  init(navigationMainEl: HTMLElement) {
    this.handleSecondLayer(navigationMainEl);
  },
};

export default navigationMain;
